<!--
 * @Description: 小标题
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px"
        v-for="(item, index) in group(TYPE_MAPPING)"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            v-for="child in item"
            :key="child.value"
            :value="child.value"
            :model-value="curItem.value"
            @click="onChange(child.value)"
          >
            <div>
              <component
                style="width: 380px"
                :is="cmpName(child.value)"
                v-bind="{
                  innerText: '项目执行人性别分布',
                  index: 1
                }"
              />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModuleTitle from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-sub-title';

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';

const CHILD_KEY = '101_3';
const TYPE_MAPPING = {
  1: {
    value: 'pc-module-sub-title-1',
    moduleType: 'pc-module-sub-title-1'
  },
  2: {
    value: 'pc-module-sub-title-2',
    moduleType: 'pc-module-sub-title-2'
  },
  3: {
    value: 'pc-module-sub-title-3',
    moduleType: 'pc-module-sub-title-3'
  },
  4: {
    value: 'pc-module-sub-title-4',
    moduleType: 'pc-module-sub-title-4'
  },
  5: {
    value: 'pc-module-sub-title-5',
    moduleType: 'pc-module-sub-title-5'
  },
  6: {
    value: 'pc-module-sub-title-6',
    moduleType: 'pc-module-sub-title-6'
  },
  7: {
    value: 'pc-module-sub-title-7',
    moduleType: 'pc-module-sub-title-7'
  },
  8: {
    value: 'pc-module-sub-title-8',
    moduleType: 'pc-module-sub-title-8'
  }
};

const cmpName = name => {
  return PcModuleTitle.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
<style scoped lang="scss"></style>
